import { Card, Col, Placeholder, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faArrowDown, faChartSimple, faCircleNodes } from "@fortawesome/free-solid-svg-icons";
import { LLMDashboardMarkdownRenderer } from "../common/LLMDashboardMarkdownRenderer";
import { ScanMulti } from "../common/models";

// Helper for risk color and arrow
const getRiskLevelStyles = (riskLevel: string) => {
    switch (riskLevel) {
        case "Low":
            return { color: "#c2eddb", icon: faArrowDown };
        case "Moderate":
            return { color: "#eee596", icon: null };
        case "High":
            return { color: "#edc2c2", icon: faArrowUp };
        case "Very High":
            return { color: "#edc2c2", icon: faArrowUp };
        default:
            return { color: "gray", icon: null };
    }
};

export const SectionRiskButton = (props: {
    isLoading: boolean,
    idx: number,
    scanMulti?: ScanMulti,
    active?: number,
    setActive: (active: number) => void,
    data: any,
    title: string,
}) => {

    return (
        <Card onClick={() => { props.setActive(props.idx) }} className={`mt-2 notes-section ${props.active === props.idx && "notes-section-active"}`}>
            <Card.Body>
                <Row>
                    <Col md={12}>
                        <strong>{props.title}</strong>
                    </Col>
                </Row>
                {
                    props.isLoading ? (
                        <Placeholder animation="glow">
                            <Placeholder xs={4} />
                        </Placeholder>
                    ) : props.data && props.data.error ? (
                        <Row>
                            <Col>{props.data.error}</Col>
                        </Row>
                    ) : props.data && props.data.risk_level_justification ? (
                        <Row className="mt-3">
                            <Col>
                                {(() => {
                                    const riskLevel = props.data.risk_level ?? "N/A";
                                    const { color, icon } = getRiskLevelStyles(riskLevel);
                                    return (
                                        <span className="risk-preview-badge me-3" style={{backgroundColor: color}}>
                                            <span className="me-2"><FontAwesomeIcon icon={faChartSimple} /></span>Percentile <strong>{props.data.probability_percentile ?? "N/A"}</strong> {icon && <FontAwesomeIcon icon={icon} style={{ marginLeft: '5px' }} />}
                                        </span>
                                    );
                                })()}
                                <span className="risk-preview-badge">
                                    <span className="me-2"><FontAwesomeIcon icon={faCircleNodes} /></span>Probability <strong>{props.data.probability ?? "N/A"}</strong>
                                </span>
                            </Col>
                        </Row>
                    ) : (
                        <Row>
                            <Col className="description-text">
                                No Data
                            </Col>
                        </Row>
                    )
                }

                {props.data && props.data.risk_level_justification && (
                    <Row className="mt-3">
                        <Col className="description-text" style={{ fontSize: '0.9em' }}>
                            <LLMDashboardMarkdownRenderer content={props.data.risk_level_justification} scanMulti={props.scanMulti} />
                        </Col>
                    </Row>
                )}
            </Card.Body>
        </Card>
    );
};
